import { moments } from "@/mocks/guage";

export default function MomentsSection() {
  return (
    <section id="moments" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-accent-700 text-xs md:text-sm font-medium">
            <span className="w-6 h-px bg-accent-500"></span>
            高能瞬间图鉴
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl text-foreground-950">名场面</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            有些画面只播两秒，却能被截图传上一整年。瓜哥把这些瞬间挑出来，配上当时的弹幕，慢慢看更有味。
          </p>
        </div>

        <div className="mt-9 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {moments.map((moment, index) => (
            <article
              key={moment.title}
              className={`group relative rounded-lg overflow-hidden border border-background-200 ${
                index % 2 === 1 ? "sm:mt-6" : ""
              }`}
            >
              <div className="relative h-72 md:h-80">
                <img
                  src={moment.image}
                  alt={`名场面：${moment.title}`}
                  title={`${moment.title} · 瓜哥吃瓜名场面`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
                <span className="absolute top-3 left-3 font-heading text-sm w-9 h-9 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-950">
                  {index + 1}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-[11px] whitespace-nowrap">
                    <i className="ri-flashlight-fill"></i>
                    {moment.heat} 次回看
                  </span>
                  <h3 className="mt-2.5 font-heading text-xl md:text-2xl text-background-50 leading-snug">
                    {moment.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-background-50/80 leading-relaxed">
                    {moment.desc}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}